export default {
  button: {
    toMainPage: "Асосӣ",
    login: "Даромад",
    registration: "Бақайдгирӣ",
    back: "Бозгашт",
    rcGroupWiki: "RC Group Wiki",
  },
  title: "Авторизатсия",
  pageTab: {
    owner: "Соҳиб",
    manager: "Менеҷер",
  },
  form: {
    country: "Кишвар",
    mail: "Почта",
    login: "Логин",
    password: "Рамз",
    repeatPass: "Такрори рамз",
    minInputSize: "Бояд ҳадди ақал {size} аломат дошта бошад",
  },
  noAccount: "Ҳисоб надоред?",
  forgotPassword: "Рамз фаромуш шудааст?",
  dontWorryAboutForgotPass:
    "Нодил нашавед, мо ба почтаи шумо пайванди бозгардониро мефиристем",

  resetPass: {
    dontWorry:
      "Нодил нашавед, мо ба почтаи шумо пайванди бозгардониро мефиристем",
    info: {
      title: "Маълумоти вуруд ба почтаи шумо фиристода шуд",
      sendedLink: "Мо пайванди тағири рамзро ба почта фиристодем",
      checkSpam: "Агар паём нагирифтед, папкаи «Спам»-ро тафтиш кунед",
    },
    resendMail: "Паёмро такрорӣ фиристед баъд аз 00:%{timer}",
    messageNotReceived: "Паём нарасид?",
    title: "Тағири рамз",
    enterNewPass:
      "Рамзи наве ворид кунед, ки барои даромад ба ҳисоби шахсӣ истифода мебаред",
  },
};
